import { localizeDigits } from '../i18n';

export const formatJalaliDateTime = (value, language = 'fa') => {
  if (!value) {
    return '—';
  }

  try {
    const isPersian = language === 'fa';
    const formatted = new Intl.DateTimeFormat(isPersian ? 'fa-IR' : 'en-US', {
      calendar: isPersian ? 'persian' : 'gregory',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).format(new Date(value));

    return isPersian ? localizeDigits(formatted, 'fa') : formatted;
  } catch {
    return '—';
  }
};
